import { render, staticRenderFns } from "./AddMessageContents.vue?vue&type=template&id=4b967c3c&scoped=true"
import script from "./AddMessageContents.vue?vue&type=script&lang=js"
export * from "./AddMessageContents.vue?vue&type=script&lang=js"
import style0 from "./AddMessageContents.vue?vue&type=style&index=0&id=4b967c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b967c3c",
  null
  
)

export default component.exports